/**
 * @generated SignedSource<<d396cbccadb6d76470f5536774035724>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedFeaturedRelatedItemsCarouselLazy_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedFeaturedRelatedItemsCarousel_user">;
  readonly " $fragmentType": "PdpSharedFeaturedRelatedItemsCarouselLazy_user";
};
export type PdpSharedFeaturedRelatedItemsCarouselLazy_user$key = {
  readonly " $data"?: PdpSharedFeaturedRelatedItemsCarouselLazy_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedFeaturedRelatedItemsCarouselLazy_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedFeaturedRelatedItemsCarouselLazy_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedFeaturedRelatedItemsCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "3b71a2c91926d86ef724002e5fcd1af9";

export default node;
